// extracted by mini-css-extract-plugin
module.exports = {"clickable-genres":"clickable-genres_clickable-genres__8jI8Q","clickable-genres__item":"clickable-genres_clickable-genres__item__E_e8B"};